import type { Fest } from "../types";

export const FESTS: Fest[] = [
  {
    id: "texas-renaissance-festival",
    name: "Texas Renaissance Festival",
    shortName: "Texas Ren Fest",
    kinds: ["renaissance"],
    region: "South",
    state: "TX",
    city: "Todd Mission",
    venue: "21778 FM 1774",
    latitude: 30.3215,
    longitude: -95.8365,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "weekend-season", "kid-friendly", "costume-welcome"],
    whyGo:
      "The largest renaissance festival in the United States: a full village, themed weekends, and a campground built for a multi-night faire trip rather than a day dash from Houston.",
    campingNotes:
      "On-site campground with tent and RV areas; season and weekend passes often include camping. Hookups are limited — treat it as dry camping unless you reserved a powered site. Quiet hours and generator rules are posted. Nearby Plantersville / Magnolia are the overflow if the campground is full.",
    tripNotes:
      "Weekends October 10 through November 29, 2026, plus Thanksgiving Friday. Gates are a morning crush; campers walk in. Fuel and groceries in Magnolia or Navasota. Confirm themed-weekend dates and camping cutoffs on texrenfest.com.",
    etiquette:
      "This is a family faire with a loud 21+ corner after dark in camp. Pack out trash, keep vehicles on designated pads, and do not treat the village as a campsite.",
    typical: {
      startMonth: 10,
      startDay: 10,
      endMonth: 11,
      endDay: 29,
      cadence: "weekends",
      notes: "Saturdays, Sundays, and Thanksgiving Friday.",
    },
    seasons: [
      {
        start: "2026-10-10",
        end: "2026-11-29",
        cadence: "weekends",
        notes: "Saturdays, Sundays, and Thanksgiving Friday.",
      },
    ],
    officialUrl: "https://www.texrenfest.com/",
  },
  {
    id: "scarborough-renaissance-festival",
    name: "Scarborough Renaissance Festival",
    shortName: "Scarborough",
    kinds: ["renaissance"],
    region: "South",
    state: "TX",
    city: "Waxahachie",
    venue: "2511 FM 66",
    latitude: 32.3328,
    longitude: -96.7675,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "rv-friendly", "weekend-season", "kid-friendly", "costume-welcome"],
    whyGo:
      "North Texas’s spring faire — a permanent village south of Dallas–Fort Worth, easy to reach, and a good first overnight if Texas Ren Fest in the fall is too far or too crowded.",
    campingNotes:
      "No village campground. Waxahachie and Midlothian have hotels; RV parks sit along I-35E. Self-contained vans sometimes use nearby parks — confirm current overnight rules. This is a nearby-camp trip, not a sleep-at-the-gate faire.",
    tripNotes:
      "Saturdays, Sundays, and Memorial Day Monday, April 4 through May 25, 2026. 10am–7pm typical. I-35E to FM 66. Tickets sell through for peak weekends.",
    etiquette:
      "Costume is welcome; weapons policies are strict. The village is compact — keep blocking for photos short on the main path.",
    typical: {
      startMonth: 4,
      startDay: 4,
      endMonth: 5,
      endDay: 25,
      cadence: "weekends",
      notes: "Saturdays, Sundays, and Memorial Day.",
    },
    seasons: [
      {
        start: "2026-04-04",
        end: "2026-05-25",
        cadence: "weekends",
        notes: "Saturdays, Sundays, and Memorial Day Monday.",
      },
    ],
    officialUrl: "https://www.srfestival.com/",
  },
  {
    id: "sherwood-forest-faire",
    name: "Sherwood Forest Faire",
    shortName: "Sherwood Forest",
    kinds: ["renaissance"],
    region: "South",
    state: "TX",
    city: "McDade",
    venue: "1883 Old Highway 20",
    latitude: 30.284,
    longitude: -97.237,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "weekend-season", "kid-friendly", "costume-welcome"],
    whyGo:
      "A wooded, camping-first faire east of Austin. If the point of the trip is to stay in garb after the gates close, this is the Texas spring answer.",
    campingNotes:
      "On-site tent and RV camping is part of the culture. Primitive-leaning; bring water and leveling. Weekend camping fills — reserve. Bastrop / Elgin are the town backups.",
    tripNotes:
      "March 1 through April 20, 2026, weekends. About 45 minutes east of Austin. Dirt and gravel in camp; rain changes the story. Confirm current camping maps on sherwoodforestfaire.com.",
    etiquette:
      "Night camp is a neighborhood. Quiet hours exist even when the tavern does not. No new fire rings; pack out.",
    typical: {
      startMonth: 3,
      startDay: 1,
      endMonth: 4,
      endDay: 20,
      cadence: "weekends",
      notes: "Late-winter / early-spring weekends.",
    },
    seasons: [
      { start: "2026-03-01", end: "2026-04-20", cadence: "weekends" },
    ],
    officialUrl: "https://www.sherwoodforestfaire.com/",
  },
  {
    id: "arizona-renaissance-festival",
    name: "Arizona Renaissance Festival",
    shortName: "Arizona Ren Fest",
    kinds: ["renaissance"],
    region: "Southwest",
    state: "AZ",
    city: "Gold Canyon",
    venue: "12601 E US Highway 60",
    latitude: 33.361,
    longitude: -111.437,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "rv-friendly", "weekend-season", "kid-friendly", "costume-welcome"],
    whyGo:
      "A desert village east of Phoenix with a long winter–spring season. The trip for anyone fleeing a northern February.",
    campingNotes:
      "Festival camping is limited; most visitors use Apache Junction / Gold Canyon RV parks or BLM desert nearby (know the current Tonto / BLM rules). Heat and dust are the camping story, not mud.",
    tripNotes:
      "February 6 through April 4, 2026, weekends. US-60 east of Phoenix. Shade, water, and a hat are not optional by March. Confirm dates on renfestinfo.com.",
    etiquette:
      "Sun is the hazard. Hydrate, cover steel in the heat, and do not wander desert washes at night without a plan.",
    typical: {
      startMonth: 2,
      startDay: 6,
      endMonth: 4,
      endDay: 4,
      cadence: "weekends",
      notes: "Nine winter–spring weekends.",
    },
    seasons: [
      { start: "2026-02-06", end: "2026-04-04", cadence: "weekends" },
    ],
    officialUrl: "https://www.renfestinfo.com/",
  },
  {
    id: "maryland-renaissance-festival",
    name: "Maryland Renaissance Festival",
    shortName: "Maryland Ren Fest",
    kinds: ["renaissance"],
    region: "Northeast",
    state: "MD",
    city: "Crownsville",
    venue: "1821 Crownsville Road",
    latitude: 39.0235,
    longitude: -76.588,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "weekend-season", "kid-friendly", "costume-welcome"],
    whyGo:
      "Revel Grove, a wooded 16th-century village outside Annapolis. One of the East Coast’s essential autumn faires — and it sells out.",
    campingNotes:
      "No on-site campground. Annapolis / Crownsville hotels book out; RV parks sit toward Baltimore and the Severn. Combine with a Chesapeake campground if you want an overnight, not a same-day I-97 dash.",
    tripNotes:
      "Saturdays, Sundays, and Labor Day Monday, August 29 through October 25, 2026. Buy tickets early. 10am–7pm typical.",
    etiquette:
      "Crowds are real. Weapons policies are posted. The grove is the point — stay on paths when the woods are wet.",
    typical: {
      startMonth: 8,
      startDay: 29,
      endMonth: 10,
      endDay: 25,
      cadence: "weekends",
      notes: "Saturdays, Sundays, and Labor Day.",
    },
    seasons: [
      {
        start: "2026-08-29",
        end: "2026-10-25",
        cadence: "weekends",
        notes: "Saturdays, Sundays, and Labor Day Monday.",
      },
    ],
    officialUrl: "https://rennfest.com/",
  },
  {
    id: "pennsylvania-renaissance-faire",
    name: "Pennsylvania Renaissance Faire",
    shortName: "Pennsylvania Ren Faire",
    kinds: ["renaissance"],
    region: "Northeast",
    state: "PA",
    city: "Manheim",
    venue: "Mount Hope Estate, 2775 Lebanon Road",
    latitude: 40.227,
    longitude: -76.426,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "weekend-season", "kid-friendly", "costume-welcome"],
    whyGo:
      "A long autumn season on a historic estate, with themed weekends and enough on-site camping to make a two-night trip the default instead of a day raid from Philly or Harrisburg.",
    campingNotes:
      "On-site camping is offered most season weekends — tent and some RV. Reserve. Lancaster County also has a deep bench of campgrounds and Amish-country hotels if the estate lots are full.",
    tripNotes:
      "August 15 through October 25, 2026, weekends. Yuletide is a separate later run some years. PA-72 near Manheim. Confirm camping on parenfaire.com.",
    etiquette:
      "Estate grounds, not a field. Stay out of gardens and historic fabric. Quiet hours in camp still apply after the taverns close.",
    typical: {
      startMonth: 8,
      startDay: 15,
      endMonth: 10,
      endDay: 25,
      cadence: "weekends",
      notes: "Long autumn weekend season.",
    },
    seasons: [
      { start: "2026-08-15", end: "2026-10-25", cadence: "weekends" },
    ],
    officialUrl: "https://www.parenfaire.com/",
  },
  {
    id: "bristol-renaissance-faire",
    name: "Bristol Renaissance Faire",
    shortName: "Bristol",
    kinds: ["renaissance"],
    region: "Midwest",
    state: "WI",
    city: "Kenosha",
    venue: "12550 120th Avenue",
    latitude: 42.531,
    longitude: -88.003,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "rv-friendly", "weekend-season", "kid-friendly", "costume-welcome"],
    whyGo:
      "The Midwest’s summer flagship faire, halfway between Chicago and Milwaukee. Strong improvisation, a permanent village, and an easy overnight if you camp the Illinois–Wisconsin line.",
    campingNotes:
      "No village campground. Kenosha, Bristol, and the Illinois state line have RV parks and hotels. Illinois Beach and nearby county parks are the scenic overnight if you want Lake Michigan instead of a parking lot.",
    tripNotes:
      "July 11 through September 7, 2026, weekends. I-94 to 120th Ave. Weekends around Labor Day are the crush.",
    etiquette:
      "Garb is welcome; the lane is crowded. Do not park overnight in the guest lots.",
    typical: {
      startMonth: 7,
      startDay: 11,
      endMonth: 9,
      endDay: 7,
      cadence: "weekends",
      notes: "Summer weekends through Labor Day.",
    },
    seasons: [
      { start: "2026-07-11", end: "2026-09-07", cadence: "weekends" },
    ],
    officialUrl: "https://renfair.com/bristol/",
  },
  {
    id: "minnesota-renaissance-festival",
    name: "Minnesota Renaissance Festival",
    shortName: "Minnesota Ren Fest",
    kinds: ["renaissance"],
    region: "Midwest",
    state: "MN",
    city: "Shakopee",
    venue: "12364 Chestnut Boulevard",
    latitude: 44.77,
    longitude: -93.486,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "weekend-season", "kid-friendly", "costume-welcome"],
    whyGo:
      "A big, well-run autumn village southwest of the Twin Cities. Plan it as a weekend with a campground on the Minnesota River, not a same-day I-494 loop.",
    campingNotes:
      "No on-site campground. Shakopee / Prior Lake hotels and Minnesota Valley campgrounds are the overnight. Louisville Swamp and nearby state parks are darker and quieter than the strip.",
    tripNotes:
      "August 22 through October 4, 2026, weekends, 9am–7pm typical. Rain or shine, and it will rain. Confirm on renaissancefest.com.",
    etiquette:
      "Mud season is a personality. Wear shoes you can wash. The village is family-heavy midday.",
    typical: {
      startMonth: 8,
      startDay: 22,
      endMonth: 10,
      endDay: 4,
      cadence: "weekends",
      notes: "Late-summer / early-fall weekends.",
    },
    seasons: [
      { start: "2026-08-22", end: "2026-10-04", cadence: "weekends" },
    ],
    officialUrl: "https://renaissancefest.com/",
  },
  {
    id: "michigan-renaissance-festival",
    name: "Michigan Renaissance Festival",
    shortName: "Michigan Ren Fest",
    kinds: ["renaissance"],
    region: "Midwest",
    state: "MI",
    city: "Holly",
    venue: "1423 S Holly Road",
    latitude: 42.81,
    longitude: -83.595,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "rv-friendly", "weekend-season", "kid-friendly", "costume-welcome"],
    whyGo:
      "Holly’s wooded village is the lower-peninsula autumn faire. Close enough to Detroit and Flint for a day, better as a camped weekend in the state-park belt.",
    campingNotes:
      "Limited or no village camping most years. Holly State Recreation Area, Ortonville, and private RV parks are the practical overnight. Book the rec area early for September weekends.",
    tripNotes:
      "August 22 through October 4, 2026, weekends. I-75 to Holly. Confirm camping and themed weekends on michrenfest.com.",
    etiquette:
      "Woods, roots, and rain. Stay on the village paths after dusk; the parking lots are not a campground.",
    typical: {
      startMonth: 8,
      startDay: 22,
      endMonth: 10,
      endDay: 4,
      cadence: "weekends",
      notes: "Seven autumn weekends.",
    },
    seasons: [
      { start: "2026-08-22", end: "2026-10-04", cadence: "weekends" },
    ],
    officialUrl: "https://www.michrenfest.com/",
  },
  {
    id: "new-york-renaissance-faire",
    name: "New York Renaissance Faire",
    shortName: "New York Ren Faire",
    kinds: ["renaissance"],
    region: "Northeast",
    state: "NY",
    city: "Tuxedo",
    venue: "600 NY-17A",
    latitude: 41.198,
    longitude: -74.214,
    overnight: "nearby",
    rvFriendly: false,
    tags: ["nearby-camp", "weekend-season", "kid-friendly", "costume-welcome"],
    whyGo:
      "A forest faire on the edge of Harriman State Park, an hour north of the city. The trip is the woods as much as the village.",
    campingNotes:
      "No on-site RV city. Harriman and Sterling Forest campgrounds / lean-tos are the move if you want to sleep in the same woods. Hotels in Tuxedo, Warwick, and the Hudson towns fill on peak weekends. Long rigs should not expect a faire-lot overnight.",
    tripNotes:
      "August 22 through October 11, 2026, weekends. NY-17 to 17A. Trains exist; driving is still the camping plan. Confirm on renfair.com/ny.",
    etiquette:
      "Park land is next door — do not spill camping onto park roads. The village paths are steep in places.",
    typical: {
      startMonth: 8,
      startDay: 22,
      endMonth: 10,
      endDay: 11,
      cadence: "weekends",
      notes: "Late-summer through early October.",
    },
    seasons: [
      { start: "2026-08-22", end: "2026-10-11", cadence: "weekends" },
    ],
    officialUrl: "https://renfair.com/ny/",
  },
  {
    id: "colorado-renaissance-festival",
    name: "Colorado Renaissance Festival",
    shortName: "Colorado Ren Fest",
    kinds: ["renaissance"],
    region: "West",
    state: "CO",
    city: "Larkspur",
    venue: "650 W Perry Park Avenue",
    latitude: 39.229,
    longitude: -104.887,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "rv-friendly", "weekend-season", "kid-friendly", "costume-welcome"],
    whyGo:
      "A hillside village between Denver and Colorado Springs. Altitude, afternoon storms, and a summer season long enough to build a trip around.",
    campingNotes:
      "Nearby private campgrounds and national-forest / park sites along I-25 are the overnight. Larkspur itself is small. Bring sun, layers, and a plan for 6,000-plus feet.",
    tripNotes:
      "Typical mid-June through early August weekends (about eight weeks). I-25 to Larkspur. Confirm 2027 dates on coloradorenaissance.com; 2026’s summer run is the usual window.",
    etiquette:
      "Hydrate. The hill is not a joke in July. Stay off neighboring ranch land at night.",
    typical: {
      startMonth: 6,
      startDay: 13,
      endMonth: 8,
      endDay: 2,
      cadence: "weekends",
      notes: "Summer weekends, roughly eight weeks.",
    },
    seasons: [
      { start: "2026-06-13", end: "2026-08-02", cadence: "weekends" },
    ],
    officialUrl: "https://www.coloradorenaissance.com/",
  },
  {
    id: "georgia-renaissance-festival",
    name: "Georgia Renaissance Festival",
    shortName: "Georgia Ren Fest",
    kinds: ["renaissance"],
    region: "Southeast",
    state: "GA",
    city: "Fairburn",
    venue: "6905 Virlyn B. Smith Road",
    latitude: 33.52,
    longitude: -84.623,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "weekend-season", "kid-friendly", "costume-welcome"],
    whyGo:
      "Atlanta’s spring faire — a full village southwest of the city, long enough to pick a themed weekend and sleep nearby instead of fighting Saturday traffic twice.",
    campingNotes:
      "No village campground. Fairburn / Peachtree City hotels and south-metro RV parks. Chattahoochee Bend or F.D. Roosevelt State Park if you want an actual camp, not a parking-lot overnight.",
    tripNotes:
      "Typical April through early June weekends (about seven weeks), Saturdays and Sundays. Confirm the 2027 opener on garenfest.com.",
    etiquette:
      "Georgia spring is hot and sudden-storm. The village is family-dense; keep steel peace-tied.",
    typical: {
      startMonth: 4,
      startDay: 11,
      endMonth: 6,
      endDay: 1,
      cadence: "weekends",
      notes: "Spring weekends, often including Memorial Day.",
    },
    seasons: [
      { start: "2026-04-11", end: "2026-06-01", cadence: "weekends" },
    ],
    officialUrl: "https://www.garenfest.com/",
  },
  {
    id: "carolina-renaissance-festival",
    name: "Carolina Renaissance Festival",
    shortName: "Carolina Ren Fest",
    kinds: ["renaissance"],
    region: "Southeast",
    state: "NC",
    city: "Huntersville",
    venue: "16445 Poplar Tent Road",
    latitude: 35.41,
    longitude: -80.849,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "rv-friendly", "weekend-season", "kid-friendly", "costume-welcome"],
    whyGo:
      "Charlotte’s autumn village — one of the larger faires in the South, with a long October–November run that rewards a two-night stay.",
    campingNotes:
      "Nearby campgrounds and RV parks north of Charlotte; Lake Norman is the scenic option. Hotels in Huntersville and Concord book out on peak weekends.",
    tripNotes:
      "October 3 through November 22, 2026, weekends. I-77 to Huntersville. Confirm on carolina.renfestinfo.com.",
    etiquette:
      "Large, loud, and family-heavy. Parking is a hike — plan for it if you have mobility needs.",
    typical: {
      startMonth: 10,
      startDay: 3,
      endMonth: 11,
      endDay: 22,
      cadence: "weekends",
      notes: "Eight autumn weekends.",
    },
    seasons: [
      { start: "2026-10-03", end: "2026-11-22", cadence: "weekends" },
    ],
    officialUrl: "https://carolina.renfestinfo.com/",
  },
  {
    id: "ohio-renaissance-festival",
    name: "Ohio Renaissance Festival",
    shortName: "Ohio Ren Fest",
    kinds: ["renaissance"],
    region: "Midwest",
    state: "OH",
    city: "Waynesville",
    venue: "7209 S US Highway 42, Harveysburg",
    latitude: 39.503,
    longitude: -84.016,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "rv-friendly", "weekend-season", "kid-friendly", "costume-welcome"],
    whyGo:
      "Southwest Ohio’s autumn faire, known for full-contact jousting and a village that runs well into October. Easy add-on to a Cincinnati or Dayton Landship loop.",
    campingNotes:
      "Nearby private campgrounds and Caesar Creek State Park. The faire lot is not an overnight. Waynesville itself is a small antique town with limited rooms.",
    tripNotes:
      "September 5 through October 25, 2026, weekends plus Labor Day. US-42. Confirm on renfestival.com.",
    etiquette:
      "The joust is the headline — give the lists room. Autumn mud is likely.",
    typical: {
      startMonth: 9,
      startDay: 5,
      endMonth: 10,
      endDay: 25,
      cadence: "weekends",
      notes: "Weekends and Labor Day.",
    },
    seasons: [
      {
        start: "2026-09-05",
        end: "2026-10-25",
        cadence: "weekends",
        notes: "Weekends and Labor Day.",
      },
    ],
    officialUrl: "https://www.renfestival.com/",
  },
  {
    id: "kansas-city-renaissance-festival",
    name: "Kansas City Renaissance Festival",
    shortName: "Kansas City Ren Fest",
    kinds: ["renaissance"],
    region: "Midwest",
    state: "KS",
    city: "Bonner Springs",
    venue: "277 N 130th Street",
    latitude: 39.067,
    longitude: -94.886,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "rv-friendly", "weekend-season", "kid-friendly", "costume-welcome"],
    whyGo:
      "A large, permanent village on the Kansas side of KC. Autumn weekends, themed days, and enough nearby camping to make it a two-night trip from Omaha, Wichita, or the city itself.",
    campingNotes:
      "Wyandotte County and western-KC RV parks; state parks toward Leavenworth / Lawrence if you want quiet. No sleeping in the guest lots.",
    tripNotes:
      "September 5 through October 18, 2026, weekends. I-70 / K-7. Confirm on kcrenfest.com.",
    etiquette:
      "Big-faire rules: peace-tied steel, posted bag checks, and patience in the lane.",
    typical: {
      startMonth: 9,
      startDay: 5,
      endMonth: 10,
      endDay: 18,
      cadence: "weekends",
      notes: "Labor Day through mid-October weekends.",
    },
    seasons: [
      { start: "2026-09-05", end: "2026-10-18", cadence: "weekends" },
    ],
    officialUrl: "https://www.kcrenfest.com/",
  },
  {
    id: "king-richards-faire",
    name: "King Richard's Faire",
    shortName: "King Richard's",
    kinds: ["renaissance"],
    region: "Northeast",
    state: "MA",
    city: "Carver",
    venue: "79 Upper Midway",
    latitude: 41.873,
    longitude: -70.771,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "weekend-season", "kid-friendly", "costume-welcome"],
    whyGo:
      "New England’s long-running autumn faire in the pine woods of Carver, between Boston and the Cape. Pair it with a Myles Standish or Plymouth overnight.",
    campingNotes:
      "Myles Standish State Forest is the camping move. Cape and Plymouth hotels are the rain plan. The faire does not run a guest campground.",
    tripNotes:
      "September 5 through October 25, 2026, weekends. MA-58. Confirm on kingrichardsfaire.net.",
    etiquette:
      "Pine roots and New England mud. Stay on paths; the woods are not a backstage.",
    typical: {
      startMonth: 9,
      startDay: 5,
      endMonth: 10,
      endDay: 25,
      cadence: "weekends",
      notes: "Labor Day through late October.",
    },
    seasons: [
      { start: "2026-09-05", end: "2026-10-25", cadence: "weekends" },
    ],
    officialUrl: "https://kingrichardsfaire.net/",
  },
  {
    id: "florida-renaissance-festival",
    name: "Florida Renaissance Festival",
    shortName: "Florida Ren Fest",
    kinds: ["renaissance"],
    region: "Southeast",
    state: "FL",
    city: "Deerfield Beach",
    venue: "Quiet Waters Park, 401 S Powerline Road",
    latitude: 26.313,
    longitude: -80.141,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "weekend-season", "kid-friendly", "costume-welcome"],
    whyGo:
      "A winter faire in a Broward County park — the trip for anyone who wants garb and jousting without a northern February.",
    campingNotes:
      "Quiet Waters has park camping in season — that is the on-the-grounds-adjacent play. Otherwise South Florida hotels. This is not a boondock faire; it is a park.",
    tripNotes:
      "February 6 through March 28, 2026, weekends, 10am to sunset. I-95 / Turnpike to Powerline. Confirm on ren-fest.com.",
    etiquette:
      "Park rules on top of faire rules. No overnight in the festival day lot. Heat and afternoon storms.",
    typical: {
      startMonth: 2,
      startDay: 6,
      endMonth: 3,
      endDay: 28,
      cadence: "weekends",
      notes: "Winter–spring weekends.",
    },
    seasons: [
      { start: "2026-02-06", end: "2026-03-28", cadence: "weekends" },
    ],
    officialUrl: "https://www.ren-fest.com/",
  },
  {
    id: "northern-california-renaissance-faire",
    name: "Northern California Renaissance Faire",
    shortName: "NorCal Ren Faire",
    kinds: ["renaissance"],
    region: "West",
    state: "CA",
    city: "Hollister",
    venue: "Casa de Fruta, Pacheco Pass",
    latitude: 37.044,
    longitude: -121.384,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "rv-friendly", "weekend-season", "kid-friendly", "costume-welcome"],
    whyGo:
      "The Bay Area’s autumn faire at Casa de Fruta — fruit-stand country with a village, and an RV park next door that makes this one of the easier West Coast overnight faires.",
    campingNotes:
      "Casa de Fruta RV park is the obvious overnight. Hollister and Gilroy hotels if you want walls. Do not expect free camping on the pass.",
    tripNotes:
      "September 19 through October 25, 2026, weekends. US-101 to Pacheco Pass (CA-152). Confirm on norcalrenfaire.com.",
    etiquette:
      "Dust, heat, and a working agricultural stop. Keep vehicles in paid camps, not orchard edges.",
    typical: {
      startMonth: 9,
      startDay: 19,
      endMonth: 10,
      endDay: 25,
      cadence: "weekends",
      notes: "Six autumn weekends.",
    },
    seasons: [
      { start: "2026-09-19", end: "2026-10-25", cadence: "weekends" },
    ],
    officialUrl: "https://www.norcalrenfaire.com/",
  },
  {
    id: "louisiana-renaissance-festival",
    name: "Louisiana Renaissance Festival",
    shortName: "Louisiana Ren Fest",
    kinds: ["renaissance"],
    region: "South",
    state: "LA",
    city: "Hammond",
    venue: "Festival grounds near Loranger",
    latitude: 30.59,
    longitude: -90.4,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "weekend-season", "kid-friendly", "costume-welcome"],
    whyGo:
      "A late-season Gulf South faire with on-site camping — useful when the rest of the country’s villages have already closed for winter.",
    campingNotes:
      "On-site tent and RV camping is a regular part of the weekend. It is still Louisiana in November: bugs, rain, and mild nights. Hammond / Ponchatoula are the town backups.",
    tripNotes:
      "November 7 through December 13, 2026, weekends. I-12 / I-55 to Hammond, then north toward Loranger. Confirm camping on larf.org.",
    etiquette:
      "Mud and mosquitoes. Pack out, and do not assume generator hours match Texas Ren Fest.",
    typical: {
      startMonth: 11,
      startDay: 7,
      endMonth: 12,
      endDay: 13,
      cadence: "weekends",
      notes: "Late-autumn weekends.",
    },
    seasons: [
      { start: "2026-11-07", end: "2026-12-13", cadence: "weekends" },
    ],
    officialUrl: "https://www.larf.org/",
  },
  {
    id: "sterling-renaissance-festival",
    name: "Sterling Renaissance Festival",
    shortName: "Sterling",
    kinds: ["renaissance"],
    region: "Northeast",
    state: "NY",
    city: "Sterling",
    venue: "15385 Farden Road",
    latitude: 43.324,
    longitude: -76.7,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "weekend-season", "kid-friendly", "costume-welcome"],
    whyGo:
      "A Lake Ontario faire with a village in the trees and a summer season that pairs naturally with a Finger Lakes or Great Lakes camping loop.",
    campingNotes:
      "Fair Haven Beach State Park is the overnight people actually want. Private camps sit toward Oswego and the lake. The faire lot is day parking.",
    tripNotes:
      "July 4 through August 16, 2026, weekends. North of Auburn / west of Oswego. Confirm on sterlingfestival.com.",
    etiquette:
      "Lake weather turns. Bring a layer. Respect park quiet hours if you camp at Fair Haven.",
    typical: {
      startMonth: 7,
      startDay: 4,
      endMonth: 8,
      endDay: 16,
      cadence: "weekends",
      notes: "Summer weekends.",
    },
    seasons: [
      { start: "2026-07-04", end: "2026-08-16", cadence: "weekends" },
    ],
    officialUrl: "https://www.sterlingfestival.com/",
  },
  {
    id: "oregon-renaissance-faire",
    name: "Oregon Renaissance Faire",
    shortName: "Oregon Ren Faire",
    kinds: ["renaissance"],
    region: "West",
    state: "OR",
    city: "Canby",
    venue: "The Vale, Canby",
    latitude: 45.271,
    longitude: -122.692,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "weekend-season", "kid-friendly", "costume-welcome"],
    whyGo:
      "A Willamette Valley faire with a short, intense June run. Easy to stack with a Portland-area camping weekend.",
    campingNotes:
      "Clackamas County and Champoeg State Park are the nearby overnight. Canby itself is small. Rain is a June personality, not a surprise.",
    tripNotes:
      "June 6 through June 28, 2026, weekends. South of Portland. Confirm on oregonrenfaire.com.",
    etiquette:
      "Mud and moss. Stay on the village paths; neighboring farms are working land.",
    typical: {
      startMonth: 6,
      startDay: 6,
      endMonth: 6,
      endDay: 28,
      cadence: "weekends",
      notes: "Four June weekends.",
    },
    seasons: [
      { start: "2026-06-06", end: "2026-06-28", cadence: "weekends" },
    ],
    officialUrl: "https://oregonrenfaire.com/",
  },
  {
    id: "washington-midsummer-renaissance-faire",
    name: "Washington Midsummer Renaissance Faire",
    shortName: "Washington Midsummer",
    kinds: ["renaissance"],
    region: "West",
    state: "WA",
    city: "Snohomish",
    venue: "Snohomish faire grounds",
    latitude: 47.912,
    longitude: -122.098,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "weekend-season", "kid-friendly", "costume-welcome"],
    whyGo:
      "Puget Sound’s summer faire, with themed weekends (including pirate) and enough nearby camping to make it a trip instead of a Seattle day.",
    campingNotes:
      "Snohomish County parks, private RV parks, and the US-2 corridor toward the mountains. Do not overnight in the guest lot.",
    tripNotes:
      "August 1 through August 16, 2026 (summer run). Confirm themed weekends on washingtonfaire.com.",
    etiquette:
      "Pacific Northwest dust-or-mud. Costume is enthusiastic; keep steel peace-tied.",
    typical: {
      startMonth: 7,
      startDay: 18,
      endMonth: 8,
      endDay: 16,
      cadence: "weekends",
      notes: "Midsummer weekends; exact span shifts by year.",
    },
    seasons: [
      { start: "2026-08-01", end: "2026-08-16", cadence: "weekends" },
    ],
    officialUrl: "https://washingtonfaire.com/",
  },
  {
    id: "pennsic-war",
    name: "Pennsic War",
    shortName: "Pennsic",
    kinds: ["historical", "renaissance"],
    region: "Northeast",
    state: "PA",
    city: "Slippery Rock",
    venue: "Cooper's Lake Campground, 205 Currie Road",
    latitude: 41.037,
    longitude: -80.079,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "costume-welcome", "living-history"],
    whyGo:
      "The SCA’s two-week medieval city. If you want to camp in period (or next to people who do) this is the largest historical camping trip on the continent.",
    campingNotes:
      "The entire event is camping: tents, period pavilions, and some RVs on Cooper’s Lake. Pre-register. Land is muddy, loud, and communal. This is not a faire day-lot — you live here. Showers and merchants exist; self-containment still helps.",
    tripNotes:
      "Pennsic 53: July 24 through August 9, 2026. Pennsic 54: July 30 through August 15, 2027. I-79 to Slippery Rock. You need event membership / registration — this is not a walk-up county fair.",
    etiquette:
      "SCA site rules, marshals, and quiet hours are real. Consent culture around photography of people in camp. Leave the lake cleaner than you found it.",
    typical: {
      startMonth: 7,
      startDay: 24,
      endMonth: 8,
      endDay: 9,
      cadence: "daily",
      notes: "About 17 days, ending the second full weekend in August.",
    },
    seasons: [
      { start: "2026-07-24", end: "2026-08-09", cadence: "daily" },
      { start: "2027-07-30", end: "2027-08-15", cadence: "daily" },
    ],
    officialUrl: "https://www.pennsicwar.org/",
  },
  {
    id: "gettysburg-reenactment",
    name: "Gettysburg Anniversary Reenactment",
    shortName: "Gettysburg",
    kinds: ["historical"],
    region: "Northeast",
    state: "PA",
    city: "Gettysburg",
    venue: "Private farmland south of the national park",
    latitude: 39.761,
    longitude: -77.231,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "rv-friendly", "single-weekend", "living-history"],
    whyGo:
      "The large annual battle reenactment on the anniversary weekend — living history, tactical demonstrations, and a town that is already a multi-night history trip.",
    campingNotes:
      "Reenactor camps are for registered participants. Spectators use Gettysburg KOA, Drummer Boy, and county campgrounds. The national park does not allow random overnighting. Hotels book out a year ahead for July 1–4.",
    tripNotes:
      "July 3–5, 2026 (163rd anniversary event). Separate from NPS ranger programs on the actual battlefield. Confirm spectator gates with the Gettysburg Battlefield Preservation Association.",
    etiquette:
      "This is someone’s sacred ground next door. Stay off NPS earthworks. Spectators do not enter the battle line. Heat in July is the other enemy.",
    typical: {
      startMonth: 7,
      startDay: 3,
      endMonth: 7,
      endDay: 5,
      cadence: "single",
      notes: "Anniversary weekend; exact days shift slightly.",
    },
    seasons: [
      { start: "2026-07-03", end: "2026-07-05", cadence: "single" },
    ],
    officialUrl: "https://www.gbpa.org/",
  },
  {
    id: "colonial-williamsburg",
    name: "Colonial Williamsburg",
    shortName: "Williamsburg",
    kinds: ["historical"],
    region: "Southeast",
    state: "VA",
    city: "Williamsburg",
    venue: "Colonial Williamsburg Historic Area",
    latitude: 37.271,
    longitude: -76.7,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "rv-friendly", "year-round", "kid-friendly", "living-history"],
    whyGo:
      "Year-round living history in an 18th-century capital, with extra reenactor weekends (including October 3–4, 2026). A trip you can take any month, not only faire season.",
    campingNotes:
      "Anvil Campground, KOA, and Newport News Park are the usual overnights. The historic area is not a campground. Combine with Jamestown / Yorktown for a full Revolutionary loop.",
    tripNotes:
      "Open year-round; programming peaks in summer and around America 250 events in 2026. Next listed military encampment weekend: October 3–4, 2026. Confirm on colonialwilliamsburg.org.",
    etiquette:
      "It is a town, not a theme park. Stay out of gardens and working kitchens. Interpreters are working.",
    typical: {
      startMonth: 1,
      startDay: 1,
      endMonth: 12,
      endDay: 31,
      cadence: "year-round",
      notes: "Daily historic area; special encampment weekends extra.",
    },
    seasons: [
      { start: "2026-01-01", end: "2026-12-31", cadence: "year-round" },
    ],
    officialUrl: "https://www.colonialwilliamsburg.org/",
  },
  {
    id: "gulf-wars",
    name: "Gulf Wars",
    shortName: "Gulf Wars",
    kinds: ["historical", "renaissance"],
    region: "South",
    state: "MS",
    city: "Lumberton",
    venue: "King's Arrow Ranch",
    latitude: 31.001,
    longitude: -89.452,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "living-history", "costume-welcome"],
    whyGo:
      "The SCA’s Gulf South war: a week of camping, armored combat, and a temporary medieval town in the piney woods. The southern counterpart to Pennsic.",
    campingNotes:
      "On-site tent and some RV camping at the ranch. Pre-register with the SCA event. Mud, humidity, and bugs are the weather. This is a camping event, not a spectator faire.",
    tripNotes:
      "Typically mid-March. Confirm the current war dates on gulfwars.org before you roll — the window moves. Hattiesburg is fuel and groceries.",
    etiquette:
      "SCA site and marshal rules. The ranch is private land — pack out, stay on roads, and treat staff as the local law.",
    typical: {
      startMonth: 3,
      startDay: 14,
      endMonth: 3,
      endDay: 22,
      cadence: "daily",
      notes: "About a week in March; confirm annually.",
    },
    seasons: [
      {
        start: "2026-03-14",
        end: "2026-03-22",
        cadence: "daily",
        notes: "Typical mid-March window — confirm on gulfwars.org.",
      },
    ],
    officialUrl: "https://www.gulfwars.org/",
  },
  {
    id: "plimoth-patuxet",
    name: "Plimoth Patuxet Museums",
    shortName: "Plimoth Patuxet",
    kinds: ["historical"],
    region: "Northeast",
    state: "MA",
    city: "Plymouth",
    venue: "137 Warren Avenue",
    latitude: 41.958,
    longitude: -70.662,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "year-round", "kid-friendly", "living-history"],
    whyGo:
      "17th-century English and Wampanoag living history on the Eel River. A slower, sourced counterpart to a faire weekend — good shoulder-season trip with Cape camping.",
    campingNotes:
      "Myles Standish State Forest is the camping move. Plymouth hotels if you want showers. Pair with King Richard’s Faire in autumn if you want garb and history in one loop.",
    tripNotes:
      "Outdoor exhibits are seasonal (typically spring through late fall); indoor museums run more of the year. Confirm hours on plimoth.org.",
    etiquette:
      "This is a museum, not a faire. Stay in visitor roles unless you are a scheduled interpreter. Photography rules are posted in homes.",
    typical: {
      startMonth: 3,
      startDay: 15,
      endMonth: 11,
      endDay: 30,
      cadence: "daily",
      notes: "Outdoor living history is seasonal.",
    },
    seasons: [
      { start: "2026-03-15", end: "2026-11-30", cadence: "daily" },
    ],
    officialUrl: "https://plimoth.org/",
  },
  {
    id: "dickens-fair",
    name: "Great Dickens Christmas Fair",
    shortName: "Dickens Fair",
    kinds: ["historical"],
    region: "West",
    state: "CA",
    city: "Daly City",
    venue: "Cow Palace",
    latitude: 37.7065,
    longitude: -122.4183,
    overnight: "day-trip",
    rvFriendly: false,
    tags: ["day-trip", "weekend-season", "kid-friendly", "costume-welcome", "living-history"],
    whyGo:
      "Victorian London indoors at the Cow Palace — a historical immersive that fills the gap after faire season ends. Costume culture is strong; camping is not the point.",
    campingNotes:
      "Bay Area hotels and a long day trip. There is no camping at the Cow Palace. If you insist on sleeping in a van, look at coastal or East Bay parks — not the Daly City lot.",
    tripNotes:
      "Typical weekends from late November through December. Confirm 2026 dates on dickensfair.com when posted.",
    etiquette:
      "Indoor immersive: bag checks, no real weapons, and crowds. Treat performers as working actors.",
    typical: {
      startMonth: 11,
      startDay: 21,
      endMonth: 12,
      endDay: 20,
      cadence: "weekends",
      notes: "Holiday weekends; exact span posted each fall.",
    },
    seasons: [
      { start: "2026-11-21", end: "2026-12-20", cadence: "weekends" },
    ],
    officialUrl: "https://dickensfair.com/",
  },
  {
    id: "may-day-faerie-festival",
    name: "May Day Faerie Festival",
    shortName: "May Day Faerie Fest",
    kinds: ["fairy"],
    region: "Northeast",
    state: "MD",
    city: "Essex",
    venue: "Rocky Point Park, 1760 Back River Neck Road",
    latitude: 39.257,
    longitude: -76.41,
    overnight: "nearby",
    rvFriendly: false,
    tags: ["nearby-camp", "single-weekend", "kid-friendly", "costume-welcome"],
    whyGo:
      "The long-running Spoutwood May Day, now on the Chesapeake at Rocky Point. Wings, maypole, and a park you can actually walk — a classic fairy-fest weekend.",
    campingNotes:
      "Park camping is not the main offer; nearby county parks and Baltimore-area campgrounds / hotels. This is a day-into-evening fest more than a sleepover village.",
    tripNotes:
      "May 2–3, 2026. I-695 to Back River Neck. Confirm on spoutwood.org. Pair with Maryland Ren Fest in the fall if you are already in the neighborhood.",
    etiquette:
      "Kid-dense and photo-happy. Ask before photographing children. Stay on park paths; the shoreline is not a stage.",
    typical: {
      startMonth: 5,
      startDay: 2,
      endMonth: 5,
      endDay: 3,
      cadence: "single",
      notes: "First weekend of May, typical.",
    },
    seasons: [
      { start: "2026-05-02", end: "2026-05-03", cadence: "single" },
    ],
    officialUrl: "https://www.spoutwood.org/faerie-festival/",
  },
  {
    id: "new-york-faerie-festival",
    name: "New York Faerie Festival",
    shortName: "NY Faerie Festival",
    kinds: ["fairy"],
    region: "Northeast",
    state: "NY",
    city: "Harpursville",
    venue: "224 Charlie Wood Road",
    latitude: 42.183,
    longitude: -75.657,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "single-weekend", "kid-friendly", "costume-welcome"],
    whyGo:
      "A camping fairy festival in the Susquehanna hills — one of the few U.S. fae events where sleeping on the land is the default, not an afterthought.",
    campingNotes:
      "On-site tent camping is the culture; some RV space. Pre-register. Vault / rustic amenities. Binghamton is the grocery town. This is a weekend you pack as if for a small music festival.",
    tripNotes:
      "June 26–28, 2026. I-88 corridor. Confirm on nyfaeriefest.com.",
    etiquette:
      "Leave-no-trace in a private woods. Ask before photos. Quiet hours exist even when the fae do not.",
    typical: {
      startMonth: 6,
      startDay: 26,
      endMonth: 6,
      endDay: 28,
      cadence: "single",
      notes: "Late-June weekend.",
    },
    seasons: [
      { start: "2026-06-26", end: "2026-06-28", cadence: "single" },
    ],
    officialUrl: "https://www.nyfaeriefest.com/",
  },
  {
    id: "faeriecon",
    name: "FaerieCon",
    shortName: "FaerieCon",
    kinds: ["fairy"],
    region: "Northeast",
    state: "MD",
    city: "Hunt Valley",
    venue: "Delta Hotels Baltimore Hunt Valley, 245 Shawan Road",
    latitude: 39.499,
    longitude: -76.656,
    overnight: "day-trip",
    rvFriendly: false,
    tags: ["day-trip", "single-weekend", "costume-welcome"],
    whyGo:
      "The indoor fae convention: authors, artists, balls, and a dealer hall. A November destination if you want fairy culture without a muddy field.",
    campingNotes:
      "This is a hotel convention. Stay on-site or nearby. Van camping in the lot is not the plan. If you want a camped Maryland fae trip, use May Day in spring instead.",
    tripNotes:
      "November 13–15, 2026. I-83 north of Baltimore. Confirm on faeriecon.com.",
    etiquette:
      "Convention rules, badge required, consent on photos. The ball is a costume space — pack like it.",
    typical: {
      startMonth: 11,
      startDay: 13,
      endMonth: 11,
      endDay: 15,
      cadence: "single",
      notes: "Mid-November weekend.",
    },
    seasons: [
      { start: "2026-11-13", end: "2026-11-15", cadence: "single" },
    ],
    officialUrl: "https://www.faeriecon.com/",
  },
  {
    id: "flathead-faerie-festival",
    name: "Flathead Faerie Festival",
    shortName: "Flathead Faerie Fest",
    kinds: ["fairy"],
    region: "West",
    state: "MT",
    city: "Kalispell",
    venue: "Flathead County Fairgrounds",
    latitude: 48.202,
    longitude: -114.316,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "single-weekend", "kid-friendly", "costume-welcome"],
    whyGo:
      "A Montana fae weekend under the Crown of the Continent. The camping is Glacier-adjacent; the fest is the excuse to put the Landship in the Flathead.",
    campingNotes:
      "Fairgrounds overnight is not the headline — Glacier, state parks, and Flathead Lake campgrounds are. Book early; July is peak in this valley.",
    tripNotes:
      "July 25–26, 2026. Free admission in recent years with a parking donation — confirm. US-93 to Kalispell.",
    etiquette:
      "Family and free-admission energy. Pack out; the valley is already crowded in July.",
    typical: {
      startMonth: 7,
      startDay: 25,
      endMonth: 7,
      endDay: 26,
      cadence: "single",
      notes: "Late-July weekend.",
    },
    seasons: [
      { start: "2026-07-25", end: "2026-07-26", cadence: "single" },
    ],
    officialUrl: "https://www.flatheadfaeriefestival.com/",
  },
  {
    id: "world-of-faeries",
    name: "World of Faeries Festival",
    shortName: "World of Faeries",
    kinds: ["fairy"],
    region: "Midwest",
    state: "IL",
    city: "South Elgin",
    venue: "LeRoy Oakes Forest Preserve area",
    latitude: 41.994,
    longitude: -88.292,
    overnight: "nearby",
    rvFriendly: false,
    tags: ["nearby-camp", "single-weekend", "kid-friendly", "costume-welcome"],
    whyGo:
      "A Fox River fairy festival in the Chicago west suburbs. Easy add-on to a Bristol weekend if you are already looping the Midwest.",
    campingNotes:
      "Forest-preserve and Fox River campgrounds, or a hotel in Elgin / St. Charles. Not an on-site sleepover.",
    tripNotes:
      "Typical early-August weekend. Confirm the current year on worldoffaeries.com before you drive.",
    etiquette:
      "Park / preserve rules. Kid-heavy. Stay on mowed festival grounds.",
    typical: {
      startMonth: 8,
      startDay: 1,
      endMonth: 8,
      endDay: 2,
      cadence: "single",
      notes: "Early-August weekend; confirm annually.",
    },
    seasons: [
      { start: "2026-08-01", end: "2026-08-02", cadence: "single" },
    ],
    officialUrl: "https://www.worldoffaeries.com/",
  },
  {
    id: "coney-island-mermaid-parade",
    name: "Coney Island Mermaid Parade",
    shortName: "Mermaid Parade",
    kinds: ["mermaid"],
    region: "Northeast",
    state: "NY",
    city: "Brooklyn",
    venue: "Surf Avenue, Coney Island",
    latitude: 40.5755,
    longitude: -73.9707,
    overnight: "day-trip",
    rvFriendly: false,
    tags: ["day-trip", "single-weekend", "costume-welcome"],
    whyGo:
      "The country’s largest art parade, and the unofficial opening of summer in New York. If mermaid meets have a cathedral, this is it.",
    campingNotes:
      "This is not a camping event. NYC hotels, a friend’s couch, or a van legally parked far from the parade route. Do not try to boondock on the Boardwalk.",
    tripNotes:
      "June 20, 2026. Parade 1pm, rain or shine, West 21st and Surf heading east. D, F, N, Q trains. Confirm on coneyisland.com.",
    etiquette:
      "Crowds, heat, and city rules. Costume is the sport; consent on photos still applies. Pack water.",
    typical: {
      startMonth: 6,
      startDay: 20,
      endMonth: 6,
      endDay: 20,
      cadence: "single",
      notes: "Third Saturday of June, typical.",
    },
    seasons: [
      { start: "2026-06-20", end: "2026-06-20", cadence: "single" },
    ],
    officialUrl: "https://www.coneyisland.com/mermaidparade",
  },
  {
    // MUSIC: San Marcos / Aqua Blues Music & Art Fest — seed this town when the music-fests catalog lands.
    id: "mermaid-capital-of-texas-fest",
    name: "Mermaid Capital of Texas Fest",
    shortName: "San Marcos Mermaids",
    kinds: ["mermaid"],
    region: "South",
    state: "TX",
    city: "San Marcos",
    venue: "Downtown San Marcos / Park Plaza",
    latitude: 29.8826,
    longitude: -97.9398,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "kid-friendly", "costume-welcome"],
    whyGo:
      "The official Mermaid Capital of Texas. A citywide river-and-costume celebration on the San Marcos River — promenade, downtown faire, and Aqua Blues Music & Art Fest — halfway between Austin and San Antonio.",
    campingNotes:
      "Downtown is day-use. Wimberley, Canyon Lake, and San Marcos RV parks are the overnight. Lockhart / Palmetto State Park if you want a quieter pad. I-35 hotels are the rain plan.",
    tripNotes:
      "The 2026 festival (May 2) was postponed. Next run: April 23 through May 2, 2027, with the Mermaid Promenade and Aqua Blues Music & Art Fest on May 1, 2027. Confirm on mermaidsocietysmtx.com/festivalinfo. San Marcos is also a music town — Aqua Blues is the festival’s stage; Cheatham Street and the river circuit are year-round.",
    etiquette:
      "The mermaids exist for the river. Stay out of springs and closed swim areas, pack out glitter that does not belong in the San Marcos, and treat downtown as a neighborhood, not a parking lot.",
    typical: {
      startMonth: 4,
      startDay: 23,
      endMonth: 5,
      endDay: 2,
      cadence: "daily",
      notes: "Late April into May; 2026 skipped. Promenade + Aqua Blues typically the Saturday.",
    },
    seasons: [
      {
        start: "2027-04-23",
        end: "2027-05-02",
        cadence: "daily",
        notes: "Citywide festival. Promenade and Aqua Blues Music & Art Fest May 1, 2027.",
      },
    ],
    officialUrl: "https://www.mermaidsocietysmtx.com/festivalinfo",
  },
  {
    id: "eastport-mermaid-festival",
    name: "Eastport Mermaid Festival",
    shortName: "Eastport Mermaids",
    kinds: ["mermaid"],
    region: "Northeast",
    state: "ME",
    city: "Eastport",
    venue: "Downtown Eastport / waterfront",
    latitude: 44.9062,
    longitude: -66.99,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "single-weekend", "kid-friendly", "costume-welcome"],
    whyGo:
      "A small-town mermaid parade at the eastern edge of the United States. The camping is Down East; the fest is the excuse to put the van on the tide.",
    campingNotes:
      "Cobscook Bay State Park and private Down East camps. Eastport has limited rooms. This is a camping trip that happens to include a mermaid parade, not the reverse.",
    tripNotes:
      "July 31 through August 1, 2026. US-1 to Eastport. Pair with the Eastport Pirate Festival in September if you like the town.",
    etiquette:
      "Tiny downtown, big costumes. Support local shops; do not block the working waterfront.",
    typical: {
      startMonth: 7,
      startDay: 31,
      endMonth: 8,
      endDay: 1,
      cadence: "single",
      notes: "Turn of July/August.",
    },
    seasons: [
      { start: "2026-07-31", end: "2026-08-01", cadence: "single" },
    ],
    officialUrl: "https://wabanaki.com/mermaid-festival/",
  },
  {
    id: "weeki-wachee-mermaids",
    name: "Weeki Wachee Mermaids",
    shortName: "Weeki Wachee",
    kinds: ["mermaid"],
    region: "Southeast",
    state: "FL",
    city: "Weeki Wachee",
    venue: "Weeki Wachee Springs State Park",
    latitude: 28.517,
    longitude: -82.573,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "rv-friendly", "year-round", "kid-friendly"],
    whyGo:
      "The original mermaid show, still in the spring. A year-round mermaid destination you can camp next to, not a one-weekend meet.",
    campingNotes:
      "The state park and nearby private RV parks are the overnight. This is one of the few mermaid sites where a van-friendly camp is part of the product. Summer heat and springs crowds — reserve.",
    tripNotes:
      "Shows run year-round; hours and swim access change. US-19. Confirm showtimes on weekiwachee.com / Florida State Parks.",
    etiquette:
      "It is a state park. The mermaids are performers with a schedule. No jumping the spring, no drones over the theater.",
    typical: {
      startMonth: 1,
      startDay: 1,
      endMonth: 12,
      endDay: 31,
      cadence: "year-round",
      notes: "Daily park; show times vary.",
    },
    seasons: [
      { start: "2026-01-01", end: "2026-12-31", cadence: "year-round" },
    ],
    officialUrl: "https://weekiwachee.com/",
  },
  {
    id: "gasparilla-pirate-fest",
    name: "Gasparilla Pirate Fest",
    shortName: "Gasparilla",
    kinds: ["pirate"],
    region: "Southeast",
    state: "FL",
    city: "Tampa",
    venue: "Bayshore Boulevard / downtown Tampa",
    latitude: 27.941,
    longitude: -82.459,
    overnight: "day-trip",
    rvFriendly: false,
    tags: ["day-trip", "single-weekend", "costume-welcome"],
    whyGo:
      "Tampa’s pirate invasion — a parade and a city weekend with more beads than a faire. The winter pirate trip if you are already in Florida for a renaissance village.",
    campingNotes:
      "City hotels and a long day. Do not plan to camp on Bayshore. If you have the van, sleep at a Gulf campground and come in for the parade.",
    tripNotes:
      "Typically late January (January 30, 2026 in the last posted run). Confirm the invasion date on gasparillapiratefest.com each fall.",
    etiquette:
      "It is a street party. Know the parade route, pack water, and do not block residents’ drives.",
    typical: {
      startMonth: 1,
      startDay: 30,
      endMonth: 1,
      endDay: 30,
      cadence: "single",
      notes: "Late January Saturday, typical.",
    },
    seasons: [
      { start: "2026-01-30", end: "2026-01-30", cadence: "single" },
    ],
    officialUrl: "https://gasparillapiratefest.com/",
  },
  {
    id: "blackbeard-pirate-festival",
    name: "Blackbeard Pirate Festival",
    shortName: "Blackbeard Festival",
    kinds: ["pirate", "historical"],
    region: "Southeast",
    state: "VA",
    city: "Hampton",
    venue: "Downtown Hampton waterfront",
    latitude: 37.027,
    longitude: -76.345,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "single-weekend", "kid-friendly", "costume-welcome", "living-history"],
    whyGo:
      "A waterfront pirate weekend in the harbor Blackbeard actually knew. Historical lectures, ships, and enough nearby camping to make it a Virginia Peninsula trip.",
    campingNotes:
      "Grandview, Newport News Park, and private RV parks. Combine with Colonial Williamsburg / Yorktown if you are already in the 250th-year loop.",
    tripNotes:
      "Typically an early-June weekend. Confirm current dates on the City of Hampton event listing before you roll.",
    etiquette:
      "Working waterfront. Stay out of marina slips. Costume steel follows city weapons rules.",
    typical: {
      startMonth: 6,
      startDay: 5,
      endMonth: 6,
      endDay: 7,
      cadence: "single",
      notes: "Early-June weekend; confirm annually.",
    },
    seasons: [
      { start: "2026-06-05", end: "2026-06-07", cadence: "single" },
    ],
    officialUrl: "https://hampton.gov/",
  },
  {
    id: "eastport-pirate-festival",
    name: "Eastport Pirate Festival",
    shortName: "Eastport Pirates",
    kinds: ["pirate"],
    region: "Northeast",
    state: "ME",
    city: "Eastport",
    venue: "Downtown Eastport",
    latitude: 44.9062,
    longitude: -66.9895,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "single-weekend", "kid-friendly", "costume-welcome"],
    whyGo:
      "Pirates take the same Down East town as the mermaid weekend, six weeks later. If you liked the waterfront in August, come back in September.",
    campingNotes:
      "Same as the mermaid festival: Cobscook Bay State Park and private camps. September is quieter than August — camping is easier.",
    tripNotes:
      "September 11–13, 2026. US-1 to Eastport. Confirm on eastportpiratefestival.com.",
    etiquette:
      "Small town, loud weekend. Support the locals who live here when the pirates leave.",
    typical: {
      startMonth: 9,
      startDay: 11,
      endMonth: 9,
      endDay: 13,
      cadence: "single",
      notes: "Mid-September weekend.",
    },
    seasons: [
      { start: "2026-09-11", end: "2026-09-13", cadence: "single" },
    ],
    officialUrl: "https://www.eastportpiratefestival.com/",
  },
  {
    id: "three-barons-renaissance-fair",
    name: "Three Barons Renaissance Fair",
    shortName: "Three Barons",
    kinds: ["renaissance", "pirate"],
    region: "Alaska",
    country: "US",
    state: "AK",
    city: "Anchorage",
    venue: "Russian Jack Springs Park North, 801 Pine Street",
    latitude: 61.2055,
    longitude: -149.805,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "weekend-season", "kid-friendly", "costume-welcome"],
    whyGo:
      "Alaska’s faire: two June weekends in Anchorage, pirate then fantasy, under a midnight-sun sky. The trip is the drive north as much as the village of Hillshire.",
    campingNotes:
      "No overnight on the park fields. Chugach State Park (Eagle River, Eklutna) and private RV parks around Anchorage are the play. Book early — June is already high season.",
    tripNotes:
      "June 6–7 (pirate) and June 13–14 (fantasy), 2026, noon–8pm. Free shuttle from UAA West Lot; do not park on the soccer fields. Confirm on 3barons.org.",
    etiquette:
      "Municipal park, no shade, no on-site parking drama. Use the shuttle. Bugs and sun are both real in June.",
    typical: {
      startMonth: 6,
      startDay: 6,
      endMonth: 6,
      endDay: 14,
      cadence: "weekends",
      notes: "First two full weekends of June.",
    },
    seasons: [
      {
        start: "2026-06-06",
        end: "2026-06-14",
        cadence: "weekends",
        notes: "June 6–7 pirate; June 13–14 fantasy.",
      },
    ],
    officialUrl: "https://3barons.org/",
  },
  {
    id: "end-of-the-road-ren-fair",
    name: "End of the Road Ren Fair",
    shortName: "End of the Road",
    kinds: ["renaissance"],
    region: "Alaska",
    country: "US",
    state: "AK",
    city: "Valdez",
    venue: "Barney Meyring Park",
    latitude: 61.1305,
    longitude: -146.348,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "single-weekend", "kid-friendly", "costume-welcome"],
    whyGo:
      "A free community faire at the end of the Richardson Highway, with mountains in every photo. If Three Barons is the city weekend, this is the road-trip sequel.",
    campingNotes:
      "Valdez has RV parks, state-park camps, and boat-harbor overflow culture. This is a camping town in June — reserve. The park itself is day-use.",
    tripNotes:
      "June 19–20, 2026, noon–8pm, free entry. AK-4 to Valdez. Weather is coastal: pack a raincoat. Confirm on the event’s Facebook / endoftheroadrenfair.org.",
    etiquette:
      "Small town, volunteer faire. Support local vendors. Do not overnight in the park lot.",
    typical: {
      startMonth: 6,
      startDay: 19,
      endMonth: 6,
      endDay: 20,
      cadence: "single",
      notes: "Mid-June weekend.",
    },
    seasons: [
      { start: "2026-06-19", end: "2026-06-20", cadence: "single" },
    ],
    officialUrl: "https://www.facebook.com/EndOfTheRoadRenFair/",
  },
  {
    id: "bicolline-grande-bataille",
    name: "Bicolline Grande Bataille",
    shortName: "Bicolline",
    kinds: ["historical", "renaissance"],
    region: "Canada",
    country: "CA",
    state: "QC",
    city: "Saint-Mathieu-du-Parc",
    venue: "Duché de Bicolline, 1480 Chemin Principal",
    latitude: 46.5762,
    longitude: -72.9019,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "costume-welcome", "living-history"],
    whyGo:
      "North America’s largest medieval LARP city: a week in a standing village of hundreds of buildings, battles, and tents. The Canadian counterpart to Pennsic — you live on site.",
    campingNotes:
      "The whole site is camp. Period pavilions, modern tents, and some buildings; lodging is part of registration and sells out. This is not a spectator faire. Self-containment helps; showers and ice exist. Montréal is the airport; the last hour is rural Québec.",
    tripNotes:
      "August 9–16, 2026 (Grande Bataille 1026). Registration is capped. Discovery Day is a separate one-day ticket. Confirm on bicolline.org. French is the working language; English is common.",
    etiquette:
      "Decorum rules on the village streets. Photography consent matters. Pack out; the Duché is private land that hosts thousands.",
    typical: {
      startMonth: 8,
      startDay: 9,
      endMonth: 8,
      endDay: 16,
      cadence: "daily",
      notes: "Mid-August week; confirm annually.",
    },
    seasons: [
      { start: "2026-08-09", end: "2026-08-16", cadence: "daily" },
    ],
    officialUrl: "https://bicolline.org/en/",
  },
  {
    id: "outland-gate-renaissance-faire",
    name: "Outland Gate Renaissance Faire",
    shortName: "Outland Gate",
    kinds: ["renaissance"],
    region: "Canada",
    country: "CA",
    state: "NB",
    city: "Harcourt",
    venue: "Stillwater Village, 7595 Route 126",
    latitude: 46.471,
    longitude: -65.253,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "single-weekend", "kid-friendly", "costume-welcome"],
    whyGo:
      "Year one of a permanent forest faire in the New Brunswick woods — Canada’s first purpose-built renaissance village, 40 minutes north of Moncton. A trip you take to be there at the beginning.",
    campingNotes:
      "Founder’s Market Day is not yet a full on-site campground. Moncton / Kent County camps and Kouchibouguac National Park are the overnight. Confirm whether village camping opens this year before you assume a pad.",
    tripNotes:
      "September 26, 2026 (Founder’s Market Day). NB-126 at Harcourt. Confirm tickets on outlandgatefaire.ca.",
    etiquette:
      "Working forest, new village. Stay on paths, pack out, and treat Year One as a construction-site-plus-faire.",
    typical: {
      startMonth: 9,
      startDay: 26,
      endMonth: 9,
      endDay: 26,
      cadence: "single",
      notes: "Late September; the site is meant to grow into a longer season.",
    },
    seasons: [
      { start: "2026-09-26", end: "2026-09-26", cadence: "single" },
    ],
    officialUrl: "https://outlandgatefaire.ca/",
  },
  {
    id: "ontario-pirate-festival",
    name: "Ontario Pirate Festival",
    shortName: "Ontario Pirates",
    kinds: ["pirate", "mermaid"],
    region: "Canada",
    country: "CA",
    state: "ON",
    city: "Guelph",
    venue: "Marden Park, 7368 Wellington Road 30",
    latitude: 43.591,
    longitude: -80.269,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "single-weekend", "kid-friendly", "costume-welcome"],
    whyGo:
      "Canada’s pirate village for the August long weekend — mermaids in an outdoor tank, sword work, and a civic-holiday trip from Toronto or Kitchener without crossing the border.",
    campingNotes:
      "Marden is a county park, not a sleepover village. Nearby conservation-area camps and Guelph / Elora hotels. Rockwood or Elora Gorge if you want an actual tent night.",
    tripNotes:
      "August 1–3, 2026, 11am–6pm daily. Tickets at the gate. Confirm on justadequate.com. Pair with a Niagara or Port Credit weekend if you are looping southern Ontario.",
    etiquette:
      "Family faire with a 19+ Captain’s Keg on Saturday night. County park rules after hours.",
    typical: {
      startMonth: 8,
      startDay: 1,
      endMonth: 8,
      endDay: 3,
      cadence: "single",
      notes: "Ontario Civic Holiday long weekend.",
    },
    seasons: [
      { start: "2026-08-01", end: "2026-08-03", cadence: "single" },
    ],
    officialUrl: "https://justadequate.com/jollyRogering/information-Pirate-Festival.htm",
  },
  {
    id: "port-credit-renaissance-faire",
    name: "Port Credit Renaissance Faire",
    shortName: "Port Credit",
    kinds: ["renaissance"],
    region: "Canada",
    country: "CA",
    state: "ON",
    city: "Mississauga",
    venue: "Port Credit Memorial Park, 40 Lakeshore Road",
    latitude: 43.5518,
    longitude: -79.586,
    overnight: "day-trip",
    rvFriendly: false,
    tags: ["day-trip", "single-weekend", "kid-friendly", "costume-welcome"],
    whyGo:
      "A lakeshore GTA faire — the easy Toronto-area village if Bicolline or a rural Ontario weekend is too far this trip.",
    campingNotes:
      "City park, day trip. Mississauga / Toronto hotels. If you have the van, camp the Niagara or Grand River parks and drive in.",
    tripNotes:
      "August 29–30, 2026. GO Transit to Port Credit is realistic. Confirm on Eventbrite / destinationontario.com listings.",
    etiquette:
      "Neighborhood park on the Credit River. Pack out, and do not treat the lot as overnight.",
    typical: {
      startMonth: 8,
      startDay: 29,
      endMonth: 8,
      endDay: 30,
      cadence: "single",
      notes: "Late-August weekend.",
    },
    seasons: [
      { start: "2026-08-29", end: "2026-08-30", cadence: "single" },
    ],
    officialUrl: "https://www.destinationontario.com/en-ca/articles/renaissance-faires-and-medieval-attractions-ontario",
  },
  {
    id: "wentworth-medieval-faire",
    name: "Wentworth Medieval Faire",
    shortName: "Wentworth",
    kinds: ["renaissance", "historical"],
    region: "Canada",
    country: "CA",
    state: "ON",
    city: "Ancaster",
    venue: "Ancaster / Wentworth faire grounds",
    latitude: 43.218,
    longitude: -79.987,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "single-weekend", "kid-friendly", "costume-welcome"],
    whyGo:
      "A Victoria Day weekend faire in the Hamilton hills — a spring opener for southern Ontario before the summer pirate and Port Credit dates.",
    campingNotes:
      "Conservation areas around Hamilton and Brantford; hotels in Ancaster. Not an on-site sleepover.",
    tripNotes:
      "May 22–24, 2026. QEW / Hwy 403 to Ancaster. Confirm current grounds and tickets before you roll.",
    etiquette:
      "Civic-holiday crowds. Peace-tied steel, pack out.",
    typical: {
      startMonth: 5,
      startDay: 22,
      endMonth: 5,
      endDay: 24,
      cadence: "single",
      notes: "Victoria Day long weekend.",
    },
    seasons: [
      { start: "2026-05-22", end: "2026-05-24", cadence: "single" },
    ],
    officialUrl: "https://renfaire.ca/directory",
  },
  {
    id: "mission-renaissance-faire",
    name: "Mission Renaissance Faire",
    shortName: "Mission Ren Faire",
    kinds: ["renaissance"],
    region: "Canada",
    country: "CA",
    state: "BC",
    city: "Mission",
    venue: "Fraser River Heritage Park, 7494 Mary Street",
    latitude: 49.1328,
    longitude: -122.303,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "single-weekend", "kid-friendly", "costume-welcome"],
    whyGo:
      "A Fraser Valley faire east of Vancouver, in a heritage park above the river. The West Coast Canadian village if you are already looping Washington Midsummer or Oregon.",
    campingNotes:
      "Cultus Lake, Sasquatch Provincial Park, and Fraser Valley RV parks. The heritage park is day-use.",
    tripNotes:
      "September 18–20, 2026. Hwy 7 to Mission. Confirm on missionartscouncil.ca.",
    etiquette:
      "Heritage park, not a field. Stay off gardens and memorials.",
    typical: {
      startMonth: 9,
      startDay: 18,
      endMonth: 9,
      endDay: 20,
      cadence: "single",
      notes: "Mid-September weekend.",
    },
    seasons: [
      { start: "2026-09-18", end: "2026-09-20", cadence: "single" },
    ],
    officialUrl: "https://missionartscouncil.ca/events/ren-faire/",
  },
  {
    id: "south-okanagan-renaissance-fair",
    name: "South Okanagan Renaissance Fair",
    shortName: "South Okanagan",
    kinds: ["renaissance"],
    region: "Canada",
    country: "CA",
    state: "BC",
    city: "Penticton",
    venue: "Gyro Park, 55 Main Street",
    latitude: 49.499,
    longitude: -119.594,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "single-weekend", "kid-friendly", "costume-welcome"],
    whyGo:
      "A desert-lakes faire in the Okanagan — wine country, heat, and a May opener on the BC interior loop.",
    campingNotes:
      "Okanagan Lake provincial camps and Penticton RV parks. Gyro Park is downtown day-use. May is shoulder season; camping is easier than July.",
    tripNotes:
      "May 30, 2026 (listed as a one-day fair). Confirm current hours. Hwy 97 to Penticton.",
    etiquette:
      "City park on the channel. Pack out; the beach is next door, not a campsite.",
    typical: {
      startMonth: 5,
      startDay: 30,
      endMonth: 5,
      endDay: 30,
      cadence: "single",
      notes: "Late May.",
    },
    seasons: [
      { start: "2026-05-30", end: "2026-05-30", cadence: "single" },
    ],
    officialUrl: "https://www.facebook.com/p/The-South-Okanagan-Renaissance-Fair-61586608154044/",
  },
  {
    id: "sidney-fairy-fantasy-faire",
    name: "Fairy and Fantasy Faire",
    shortName: "Sidney Fairy Faire",
    kinds: ["fairy"],
    region: "Canada",
    country: "CA",
    state: "BC",
    city: "Sidney",
    venue: "2243 Beacon Avenue",
    latitude: 48.6504,
    longitude: -123.3987,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "single-weekend", "kid-friendly", "costume-welcome"],
    whyGo:
      "A Vancouver Island fae weekend at the start of spring — pair it with the ferry and a Gulf Islands camp if you want wings without flying to Maryland.",
    campingNotes:
      "Island View Beach, McDonald Campground, and Saanich RV parks. Sidney itself is a walkable town, not a boondock.",
    tripNotes:
      "March 28–29, 2026. Swartz Bay ferry from Tsawwassen. Confirm on faerieevents.ca. Sails & Sagas (pirate/viking) returns to Sidney in late August.",
    etiquette:
      "Kid-dense indoor/outdoor mix. Ask before photos.",
    typical: {
      startMonth: 3,
      startDay: 28,
      endMonth: 3,
      endDay: 29,
      cadence: "single",
      notes: "Late-March weekend.",
    },
    seasons: [
      { start: "2026-03-28", end: "2026-03-29", cadence: "single" },
    ],
    officialUrl: "https://www.faerieevents.ca/",
  },
  {
    id: "strathmore-medieval-faire",
    name: "Strathmore Medieval Faire",
    shortName: "Strathmore",
    kinds: ["renaissance"],
    region: "Canada",
    country: "CA",
    state: "AB",
    city: "Strathmore",
    venue: "Strathmore & District Agricultural Society grounds",
    latitude: 51.0378,
    longitude: -113.4,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "rv-friendly", "single-weekend", "kid-friendly", "costume-welcome"],
    whyGo:
      "A late-August prairie faire east of Calgary with full-contact jousting and a real artisan market. Easy add-on to a Banff / Badlands camping loop.",
    campingNotes:
      "Ag-society overnight is sometimes offered — confirm. Otherwise private RV parks in Strathmore and provincial camps toward Drumheller. Calgary hotels if weather turns.",
    tripNotes:
      "August 21–23, 2026. Trans-Canada to Strathmore. Confirm current dates locally.",
    etiquette:
      "Prairie wind and sun. Give the lists room. Pack a layer.",
    typical: {
      startMonth: 8,
      startDay: 21,
      endMonth: 8,
      endDay: 23,
      cadence: "single",
      notes: "Late-August weekend.",
    },
    seasons: [
      { start: "2026-08-21", end: "2026-08-23", cadence: "single" },
    ],
    officialUrl: "https://renfaire.ca/directory",
  },
  {
    id: "edson-medieval-faire",
    name: "Edson Medieval Faire",
    shortName: "Edson",
    kinds: ["renaissance"],
    region: "Canada",
    country: "CA",
    state: "AB",
    city: "Edson",
    venue: "Edson faire grounds",
    latitude: 53.5817,
    longitude: -116.434,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "rv-friendly", "single-weekend", "kid-friendly", "costume-welcome"],
    whyGo:
      "A Yellowhead Highway faire west of Edmonton, with enough nearby camping and trail country to make it a weekend instead of a day raid.",
    campingNotes:
      "Municipal and provincial camps around Edson; private RV parks on Hwy 16. This is a camping-friendly prairie-and-forest town in July.",
    tripNotes:
      "July 24–26, 2026. Hwy 16. Confirm locally before you commit the drive from Edmonton or Jasper.",
    etiquette:
      "Small-town faire. Support the vendors who hauled out here.",
    typical: {
      startMonth: 7,
      startDay: 24,
      endMonth: 7,
      endDay: 26,
      cadence: "single",
      notes: "Late-July weekend.",
    },
    seasons: [
      { start: "2026-07-24", end: "2026-07-26", cadence: "single" },
    ],
    officialUrl: "https://renfaire.ca/directory",
  },
  {
    id: "cooks-creek-medieval-festival",
    name: "Cook's Creek Medieval Festival",
    shortName: "Cook's Creek",
    kinds: ["renaissance", "historical"],
    region: "Canada",
    country: "CA",
    state: "MB",
    city: "Cook's Creek",
    venue: "Cook's Creek festival grounds",
    latitude: 50.015,
    longitude: -96.773,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "single-weekend", "kid-friendly", "costume-welcome"],
    whyGo:
      "Manitoba’s medieval weekend east of Winnipeg — the prairie pin so the map is not only coasts and Alberta.",
    campingNotes:
      "Birds Hill Provincial Park is the obvious overnight from Winnipeg. Cook’s Creek itself is rural; confirm any on-site camping year to year.",
    tripNotes:
      "July 25–26, 2026. Hwy 59 / 213 east of the city. Confirm current dates.",
    etiquette:
      "Small community festival. Pack out; the field is someone’s backyard at scale.",
    typical: {
      startMonth: 7,
      startDay: 25,
      endMonth: 7,
      endDay: 26,
      cadence: "single",
      notes: "Late-July weekend.",
    },
    seasons: [
      { start: "2026-07-25", end: "2026-07-26", cadence: "single" },
    ],
    officialUrl: "https://renfaire.ca/directory",
  },
  {
    id: "nl-renaissance-festival",
    name: "Newfoundland Renaissance Festival",
    shortName: "NL Ren Fest",
    kinds: ["renaissance"],
    region: "Canada",
    country: "CA",
    state: "NL",
    city: "Mount Pearl",
    venue: "Mount Pearl festival grounds",
    latitude: 47.5189,
    longitude: -52.807,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "single-weekend", "kid-friendly", "costume-welcome"],
    whyGo:
      "The island faire — if you are already flying or sailing to Newfoundland, this is the garb weekend. Pair with the Eastport mermaid trip only if you like ferries.",
    campingNotes:
      "Pippy Park in St. John’s is the practical RV/tent overnight. Mount Pearl is a city suburb; the faire lot is not a campground.",
    tripNotes:
      "August 22–23, 2026. Confirm locally. Weather is North Atlantic: layers, rain gear.",
    etiquette:
      "Wind and weather. Support local makers who imported less and built more.",
    typical: {
      startMonth: 8,
      startDay: 22,
      endMonth: 8,
      endDay: 23,
      cadence: "single",
      notes: "Late-August weekend.",
    },
    seasons: [
      { start: "2026-08-22", end: "2026-08-23", cadence: "single" },
    ],
    officialUrl: "https://renfaire.ca/directory",
  },
  {
    id: "fortress-of-louisbourg",
    name: "Fortress of Louisbourg",
    shortName: "Louisbourg",
    kinds: ["historical"],
    region: "Canada",
    country: "CA",
    state: "NS",
    city: "Louisbourg",
    venue: "Fortress of Louisbourg National Historic Site",
    latitude: 45.892,
    longitude: -59.986,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "rv-friendly", "kid-friendly", "living-history"],
    whyGo:
      "An 18th-century French fortified town rebuilt on Cape Breton — Parks Canada living history you can camp next to, any summer week, not only a faire Saturday.",
    campingNotes:
      "Louisbourg RV & Camping and nearby provincial camps. The fortress is day-use. Combine with the Cabot Trail if you are already on the island.",
    tripNotes:
      "Outdoor historic area is seasonal (typically June through October). Confirm hours on parks.canada.ca. Hwy 22 from Sydney.",
    etiquette:
      "It is a national historic site. Interpreters are working. Stay off earthworks and out of closed buildings.",
    typical: {
      startMonth: 6,
      startDay: 1,
      endMonth: 10,
      endDay: 15,
      cadence: "daily",
      notes: "Seasonal historic site, not a single weekend.",
    },
    seasons: [
      { start: "2026-06-01", end: "2026-10-15", cadence: "daily" },
    ],
    officialUrl: "https://parks.canada.ca/lhn-nhs/ns/louisbourg",
  },
];

export function festById(id: string): Fest | undefined {
  return FESTS.find((fest) => fest.id === id);
}

export const REGIONS: Array<Fest["region"]> = [
  "Northeast",
  "Southeast",
  "Midwest",
  "South",
  "Southwest",
  "West",
  "Alaska",
  "Canada",
];

export const KINDS: Array<Fest["kinds"][number]> = [
  "renaissance",
  "historical",
  "fairy",
  "mermaid",
  "pirate",
];
